'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import type { MenuItem } from './MenuItems';
import { isExternalHref } from './MenuItems';
type MenuIconSize = 'sm' | 'md' | 'lg';
const sizeConfig = {
  sm: {
    bg: 'size-60',
    icon: 'size-36',
    round: 'rounded-large',
    gap: 'gap-4',
    text: 'typo-caption1'
  },
  md: {
    bg: 'size-52',
    icon: 'size-40',
    round: 'rounded-large',
    gap: 'gap-8',
    text: 'typo-body4'
  },
  lg: {
    bg: 'size-80',
    icon: 'size-60',
    round: 'rounded-xxlarge',
    gap: 'gap-8',
    text: 'typo-body4'
  }
} as const;
const getBgHoverClass = (iconBg?: string, size?: MenuIconSize) => {
  if (iconBg === 'bg-Gray-black') return '';
  if (iconBg === 'bg-B-25') return 'group-hover:bg-B-50 group-active:bg-B-100';
  if (size === 'sm') return 'group-hover:bg-Gray-300 group-active:bg-Gray-400';
  return 'group-hover:bg-Gray-100 group-active:bg-Gray-200';
};
export const MenuIconItem = t0 => {
  const $ = _c(36);
  let className;
  let href;
  let item;
  let linkProps;
  let onClick;
  let t1;
  if ($[0] !== t0) {
    ({
      item,
      size: t1,
      href,
      onClick,
      className,
      ...linkProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = href;
    $[3] = item;
    $[4] = linkProps;
    $[5] = onClick;
    $[6] = t1;
  } else {
    className = $[1];
    href = $[2];
    item = $[3];
    linkProps = $[4];
    onClick = $[5];
    t1 = $[6];
  }
  const size = t1 === undefined ? "md" : t1;
  const config = sizeConfig[size];
  const isExternal = isExternalHref(item.href);
  const resolvedHref = href ?? item.href;
  const t2 = isExternal ? "_blank" : undefined;
  const t3 = isExternal ? "noopener noreferrer" : undefined;
  let t4;
  if ($[7] !== className || $[8] !== config.gap) {
    t4 = cn("group flex w-80 flex-col items-center", config.gap, className);
    $[7] = className;
    $[8] = config.gap;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = item.iconBg ?? (size === "sm" ? "bg-Gray-200" : "bg-Gray-50");
  let t6;
  if ($[10] !== config.bg || $[11] !== config.round || $[12] !== item.iconBg || $[13] !== size || $[14] !== t5) {
    t6 = cn("flex items-center justify-center overflow-hidden transition-colors duration-200 ease-out motion-reduce:transition-none", config.bg, config.round, t5, getBgHoverClass(item.iconBg, size));
    $[10] = config.bg;
    $[11] = config.round;
    $[12] = item.iconBg;
    $[13] = size;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== config.icon || $[17] !== item.Icon) {
    t7 = <item.Icon originalFill={true} className={config.icon} />;
    $[16] = config.icon;
    $[17] = item.Icon;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <span className={t6}>{t7}</span>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const t9 = item.label;
  let t10;
  if ($[22] !== config.text) {
    t10 = cn("line-clamp-2 min-w-full break-keep text-center font-400 text-Gray-900", config.text);
    $[22] = config.text;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== item.label || $[25] !== t10) {
    t11 = <span title={t9} className={t10}>{item.label}</span>;
    $[24] = item.label;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== linkProps || $[28] !== onClick || $[29] !== resolvedHref || $[30] !== t11 || $[31] !== t2 || $[32] !== t3 || $[33] !== t4 || $[34] !== t8) {
    t12 = <CustomLink href={resolvedHref} target={t2} rel={t3} onClick={onClick} className={t4} {...linkProps}>{t8}{t11}</CustomLink>;
    $[27] = linkProps;
    $[28] = onClick;
    $[29] = resolvedHref;
    $[30] = t11;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t8;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};